import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

type LoadingMode = 'inline' | 'overlay';
type LoadingSize = 'sm' | 'md' | 'lg' | number;

@Component({
  selector: 'app-loading-spinner',
  standalone: true,
  imports: [CommonModule, ProgressSpinnerModule],
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.scss']
})
export class LoadingSpinnerComponent {
  @Input() show = false;
  @Input() mode: LoadingMode = 'inline';
  @Input() size: LoadingSize = 36;
  @Input() label?: string;
  @Input() color = '#23C02E';
  @Input() backdrop = true;

  get ariaLabel(): string {
    return this.label || 'Carregando';
  }

  get hostStyles(): Record<string, string> {
    return {
      '--ls-color': this.color,
      '--ls-size': this.resolveSize()
    } as Record<string, string>;
  }

  get sizeClass(): string {
    return typeof this.size === 'string' ? `ls-${this.size}` : '';
  }

  private resolveSize(): string {
    if (typeof this.size === 'number') return `${this.size}px`;
    if (this.size === 'sm') return '20px';
    if (this.size === 'lg') return '40px';
    return '28px';
  }

  get resolvedSize(): string {
    return this.resolveSize();
  }
}
